<script>
export default {
  name: "DrawerInfoAmenities",
  props: {
    amenities: {
      type: Array,
      required: true
    }
  },
  methods: {
    getAmenityIcon(amenity) {
      switch (amenity.toLowerCase()) {
        case "park":
          return "IconPark";
        case "restoration":
          return "IconRestaurant";
        case "internet_access":
          return "IconWifi";
        case "lodging":
          return "IconLodging";
        case "drinks":
          return "IconDrinks";
        case "shop":
          return "IconShop";
        case "restroom":
          return "IconRestroom";
        case "tourist_attraction":
          return "IconTouristAttraction";
        case "baby_area":
          return "IconBabyChanging";
        default:
          return "";
      }
    }
  }
};
</script>

<template>
    <div class="flex flex-row flex-wrap gap-2 justify-between">
        <span
            class="text-secondary-neutral text-center font-medium tracking-wider w-full mx-auto mb-4 uppercase"
        >
            {{ $t("tab_info.amenities.title") }}
        </span>
        <div
            v-for="amenity in amenities"
            :key="amenity"
            class="flex-[1_0_48%] md:flex-[1_0_49%]"
        >
            <div
                class="flex flex-col px-2 py-3.5 bg-white rounded-lg border text-primary-neutral border-zinc-200 justify-center items-center gap-2"
            >
                <component
                    :is="getAmenityIcon(amenity)"
                    class="size-10"
                    is-solid
                />
                <span>
                    {{ $t("amenities." + amenity) }}
                </span>
            </div>
        </div>
    </div>
</template>
